import { render, staticRenderFns } from "./SRadarStemdoersTechs.vue?vue&type=template&id=1242eed9"
import script from "./sRadarStemdoersTechs.ts?vue&type=script&lang=ts&external"
export * from "./sRadarStemdoersTechs.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports